// types.ts
import { combineReducers } from 'redux';
import courseReducer from './reducers/courseReducer';
import moduleReducer from './reducers/moduleReducer';
import progresReducer from './reducers/progresReducer';
import prevModelReducer from './reducers/prevModelReducer';
import { activityReducer } from './reducers/moduleActivityReducer';
import skillsDataReducer from './reducers/skillsDataReducer';


export const rootReducer = combineReducers({
  courseNames: courseReducer,
  currentModule: moduleReducer,
  prevModelReducer: prevModelReducer,
  currentProgres: progresReducer,
  moduleActivity: activityReducer,
  skillsDataReducer: skillsDataReducer,

});

export type RootState = ReturnType<typeof rootReducer>;
